(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- glyph scramble ----
  function scramble(el, delay){
    var final = el.getAttribute('data-text') || el.textContent;
    if(reduce){ el.textContent = final; return; }
    var chars = "ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789/\\<>[]{}#*=+";
    var resolved = 0, frame = 0, iv;
    function tick(){
      var out = "";
      for(var i=0;i<final.length;i++){
        var ch = final.charAt(i);
        if(ch === " "){ out += " "; continue; }
        out += (i < resolved) ? ch : chars.charAt(Math.floor(Math.random()*chars.length));
      }
      el.textContent = out;
      frame++;
      if(frame % 2 === 0) resolved++;
      if(resolved > final.length){ clearInterval(iv); el.textContent = final; }
    }
    setTimeout(function(){ iv = setInterval(tick, 32); }, delay||0);
  }
  var scs = document.querySelectorAll('.sc');
  for(var i=0;i<scs.length;i++){ scramble(scs[i], (reduce?0:1600) + i*260); }

  // ---- scroll reveal ----
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    var rv = document.querySelectorAll('.reveal');
    for(var j=0;j<rv.length;j++){ io.observe(rv[j]); }
  } else {
    var all = document.querySelectorAll('.reveal');
    for(var k=0;k<all.length;k++){ all[k].classList.add('in'); }
  }

  // ---- custom cursor ----
  var cur = document.getElementById('cur');
  if(cur && !reduce && window.matchMedia('(hover:hover)').matches){
    var x=0,y=0,cx=0,cy=0;
    document.addEventListener('mousemove', function(e){ x=e.clientX; y=e.clientY; cur.classList.add('on'); });
    document.addEventListener('mouseleave', function(){ cur.classList.remove('on'); });
    (function loop(){ cx += (x-cx)*.2; cy += (y-cy)*.2; cur.style.left=cx+'px'; cur.style.top=cy+'px'; requestAnimationFrame(loop); })();
    var hots = document.querySelectorAll('a, button, [data-hot]');
    for(var h=0;h<hots.length;h++){
      hots[h].addEventListener('mouseenter', function(){ cur.classList.add('hot'); });
      hots[h].addEventListener('mouseleave', function(){ cur.classList.remove('hot'); });
    }
  }

  // ---- mobile menu ----
  var burger = document.getElementById('burger');
  if(burger){
    burger.addEventListener('click', function(){
      var n = document.querySelector('.nav-links');
      if(!n) return;
      var open = n.style.display === 'flex';
      n.style.display = open ? '' : 'flex';
      if(!open){ n.style.position='absolute'; n.style.top='60px'; n.style.left='0'; n.style.right='0'; n.style.flexDirection='column'; n.style.gap='18px'; n.style.padding='20px var(--gut)'; n.style.background='var(--bg)'; n.style.borderBottom='1px solid var(--line)'; }
    });
  }
})();